<div class="container-fluid offers">
  <div class="row main-row">
    <div *ngFor="let locker of lockers" (click)="selectProduct(locker)" class="item d-flex justify-content-center p-0 mt-4 mb-4 m-md-2 m-lg-2 m-xl-2 col-sm-12 col-md col-lg col-xl {{locker.available || forceAvailabled ? '' : 'disabled'}}">
      <div class="c-card p-2 p-lg-4 p-xl-4">
        <div class="card">
          <h5 class="card-title">{{locker|traduccion:'name'}}</h5>
          <!-- <img src="assets/svg/locker_{{locker.id | lowercase}}.svg" class="card-img-top" alt="{{locker.id | lowercase}}"> -->

          <img [src]="getLockerImage(locker)"
          [attr.srcset]="getLockerSrcSet(locker)"
          class="card-img-top"
          alt="{{locker.id | lowercase}}" />

          <div class="card-body">
              <div class="card-text">
                  <div class="container-fluid">
                      <div class="row description" #description>
                          <div class="col">
                            <p>
                              {{locker|traduccion:'description'}}
                            </p>
                          </div>
                      </div>
                      <div *ngIf="prices">
                        <div *ngIf="mode === ModeEnum.PRICE_SIZE" class="row info-price">
                          <div class="col price">
                            <span *ngIf="prices.items[locker.id]?.price.priceWithoutDiscount != prices.items[locker.id]?.price.price"><del>{{prices.items[locker.id]?.price.priceWithoutDiscount}}€</del></span>
                            <span class="price-unit"> {{prices.items[locker.id]?.price.price}}{{'offterlocker.price_for_locker'|traduccion}}</span>
                          </div>
                        </div>
                        <div class="promotions" #promotions>
                          <div *ngFor="let promotion of prices.items[locker.id]?.promotions" [class.discountActive]="promotion.active" class="promotion">
                            <div class="row">
                              <div class="col promotion-name">
                                <p>{{promotion.name|traduccion}}</p>
                              </div>
                              <div class="col promotion-value">
                                <p>{{promotion.value}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row link-reserve">
                        <div class="col-12">
                          <a *ngIf="mode === ModeEnum.LINK_TYPE" (click)="onClickCategory(locker)" class="btn btn-primary">{{'offterlocker.reserve'|traduccion}}</a>
                          <!--<a *ngIf="mode === ModeEnum.LINK_SIZE" [routerLink]="['/reserve', appService.kiosk, 'locker-date']" [queryParams]="generateParams(locker)" class="btn btn-primary">{{'offterlocker.reserve'|traduccion}}</a>-->
                        </div>
                      </div>
                      <div *ngIf="mode === ModeEnum.PRICE_SIZE" class="row select-number">
                        <div class="col-sm-12 col-lg-5">
                          <p>{{'offterlocker.lockernumber'|traduccion}}</p>
                        </div>
                        <div class="col-sm-12 col-lg-7 m-0 p-0 align-self-center">
                          <div class="c-button">
                            <button (click)="less(locker)" class="btn btn-primary btn-just-icon"><i class="nc-icon nc-simple-delete"></i></button>
                            <span>{{ getAmount(locker)}}</span>
                            <button (click)="plus(locker)" [disabled]="getAmount(locker) >= locker.available" class="btn btn-primary btn-just-icon"><i class="nc-icon nc-simple-add"></i></button>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
          </div>
        </div>
      </div>
    </div> <!-- /col -->
  </div> <!--- /row -->
</div>



  

  
  
